define('cartware_checkout/components/checkout',[
	// dependencies
	"jquery",
	"cartware/components/_base",
	"cartware/dom/event/trigger",
	"cartware/jquery/bem",
	"cartware_checkout",
	"cartware_checkout/classes/accordeon",

	// advises
	"./advises/login",
	"./advises/billing",
	"./advises/checkout",
	"./advises/payment",
	"./advises/regionUpdater",
	"./advises/review",
	"./advises/shipping",
	"./advises/shippingMethod",

	// shims
	"garlicjs",
	"bootstrap-tooltip",
	"bootstrap-popover",
	"bootstrap-button"
], function(
	jQuery,
	Component,
	triggerEvent,
	BEM,
	CartwareCheckout,
	AccordionReplacement,

	LoginAdvise,
	BillingAdvise,
	CheckoutAdvise,
	PaymentAdvise,
	RegionUpdaterAdvise,
	ReviewAdvise,
	ShippingAdvise,
	ShippingMethodAdvise
) {
	var prototypeJs = $,
		$ = jQuery;

	var features = {
		garlic: true
	};

	// Add ECMA262-5 Array methods if not supported natively
	if (!('indexOf' in Array.prototype)) {
		Array.prototype.indexOf= function(find, i /*opt*/) {
			if (i===undefined) i= 0;
			if (i<0) i+= this.length;
			if (i<0) i= 0;
			for (var n= this.length; i<n; i++)
				if (i in this && this[i]===find)
					return i;
			return -1;
		};
	}

	return Component.create({
		block:		null,
		accordion:	null,
		checkout:	null,

		init: function() {
			var advises = [
				LoginAdvise,
				BillingAdvise,
				CheckoutAdvise,
				PaymentAdvise,
				RegionUpdaterAdvise,
				ReviewAdvise,
				ShippingAdvise,
				ShippingMethodAdvise
			];

			_.forEach(advises, function(Advise) {
				(new Advise).init();
			});
		},

		$init: function() {
			var self = this;

			this.block = BEM.block("cartware-checkout");
			this.accordion = new AccordionReplacement(this.block);

			this.checkout = new Checkout(this.accordion, this.block.data("checkout-config"));

			// Expose globally
			window.accordion = this.accordion;
			window.checkout = this.checkout;

			this.initializeBilling();

			CartwareCheckout().flag("ready");

			CartwareCheckout().retrieve("shipping", function(shipping) {
				CartwareCheckout().retrieve("billing", function(billing) {
					if (features.garlic) {
						self.initializeGarlic();
					}
				});
			});
		},

		initializeBilling: function() {
			var billingAddressBlock = $('#billing-address')
				, checkbox = $('input[name="billing[different_from_shipping]"]');

			function onChange() {
				var checked = checkbox.prop('checked');
				billingAddressBlock.css('display', checked ? 'block' : 'none');
			}

			checkbox.on('change garlic.retrieve', onChange);
			onChange();
		},

		initializeGarlic: function() {
			var filledTextArrays = [];

			this.block.find('#co-shipping-form, #co-billing-form').garlic({
				expires: 3600,
				onRetrieve: function (elem, value) {
					var node = elem.get(0)
						, nodeName = node.nodeName.toLowerCase()
						, formName = elem.prop('name');

					switch (nodeName) {
						case 'select':
							triggerEvent(node, 'change');

							if (formName.match(/\[region_id\]/)) {
								setTimeout(function() {
									elem.prop('value', value);
									triggerEvent(node, 'change');
								}, 10);
							}
							break;

						case 'input':
							switch (node.type.toLowerCase()) {
								case 'text':
									if (formName.substr(formName.length - 2) === "[]") {
										if (filledTextArrays.indexOf(formName) >= 0) {
											elem.prop('value', '');
										} else {
											filledTextArrays.push(formName);
										}
									}
									break;

								case 'radio':
								case 'checkbox':
									//$('*[name="' + elem.prop('name') + '"]').each(function () {
									//	var uniform = $(this).data('uniformed');
									//	uniform && uniform.update();
									//});
									if (node.checked && node.onclick) {
										triggerEvent(node, 'click');
									}
									break;
							}
							break;

						//default:
						//	var uniform = elem.data('uniformed');
						//	uniform && uniform.update();
						//	break;
					}

					elem.trigger('garlic.retrieve');
				}
			});
		}
	});
});
